import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { withLocalize } from 'react-localize-redux';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Image } from 'semantic-ui-react';
import { Project } from '../../../common/constant';
import { getRandColor } from '../../../common/tagColorPreset';
import { formatDate } from '../../../common/datetime';
import { CategoryLabel } from '../../../../uiStandard/event/label';

const FeaturedTile = (props) => {
  const { event, activeLanguage, translate } = props;
  const {
    bannerBg, name, tags, start, end, timezone
  } = event;

  const startDate = formatDate(start, activeLanguage, timezone);
  const endDate = formatDate(end, activeLanguage, timezone);

  const clickEvent = (e) => {
    e.preventDefault();
    props.push(`/event/${event.slug}`);
  };

  const renderLocation = () => {
    const { event } = props;
    const { isOnline, location } = event;

    let address = '';
    if (location) {
      address = get(JSON.parse(location), 'value.address');
    }
    if (isOnline === 'hybrid') {
      return <Address>{translate('eventInfo.hybridHackathon')}</Address>;
    }
    if ((isOnline === 'offline' || isOnline === 'online') && address && address.formattedAddress) {
      return <Address>{translate('eventInfo.inPersonHackathon')}</Address>;
    }
    return <Address>{translate('eventInfo.onlineHackathon')}</Address>;
  };

  return (
    <Card onClick={clickEvent}>
      <ImageContainer>
        <Featured>
          <img
            src='/img/icons/featured-Icon.svg'
            alt='Featured' width='14'
            height='14'
          /> <span>Featured</span>
        </Featured>
        <Image src={bannerBg || Project.defaultCoverImage} alt={event.name} />
      </ImageContainer>
      <CardContent>
        { renderLocation()}
        <Name className='name'>{name}</Name>
        <Date>{startDate} - {endDate}</Date>
        <TagsContainer>
          {
            tags && (
              tags.map((tag, index) => {
                const randColorObj = getRandColor();
                return (
                  <StyledLabel
                    key={`${index}-${tag}`} category='category'
                    isRound
                    bg={randColorObj.bg}
                    color={randColorObj.color}
                  >{tag}
                  </StyledLabel>
                );
                })
            )
          }
        </TagsContainer>
      </CardContent>
    </Card>
  );
};

const Card = styled.div`
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E7EDF5;
  border-radius: 12px;
  min-height: 176px;
  overflow:hidden;
  display: flex;
  justify-content:center;
  align-items:center;
  transition: all 0.1s linear;
  text-align:left;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  padding: 0.4rem;
  cursor: pointer;
  :hover {
    transform: translateY(-5px);
  }
  @media only screen and (max-width: 768px) { 
      flex-direction: column;
      height: auto;
      padding: 1em 0;
      margin: 1em auto;
  }

  @media only screen and (max-width: 375px) { 
    padding: 1em;
    width: 90%;
  }
`;

export const StyledLabel = styled(CategoryLabel)`
  color: ${(props) => (props.color ? props.color : '#0094FB')};
  background: ${(props) => (props.bg ? props.bg : '#CCEAFE')};
  && {
    margin: 0.2em;
    padding: 0 0.8em;
  }
`;

const Name = styled.h2`
  font-family: 'Inter';
  font-style: normal;
  color: #101828;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  margin: 0.1em 0;
  width: 100%;
  text-align:left;
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
`;

const Date = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #101828;
`;

export const TagsContainer = styled.div`
  width: 100%;
  text-align:left;
  padding: 0.1em;
  display: flex;
  flex-wrap: wrap;

  span {
    padding: 0.1rem 0.6rem;
    font-size: 12px;
    font-family: 'Inter';
    margin: 0.1rem;
  }
`;

const ImageContainer = styled.div`
  width: 40%;
  height: calc(176px * 0.8);
  border-radius: 8px;
  position: relative;
  cursor: pointer;

  @media only screen and (max-width: 768px) { 
    width:80%;
    max-height: 452px;
    height: auto;
  }
  @media only screen and (max-width: 510px) { 
    width: 96%;
  }
  @media only screen and (max-width: 375px) { 
    width: 100%;
    border-radius: 0;
  }

  &&.inter {
    font-family: 'Inter';
    font-style: normal;
    color: #06152B;
    font-weight: 600;
  }

  && {
    .dimmable {
      width: 100%;
      height: 100%;
    }
    img.ui.image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
}
`;

const Featured = styled.span`
  position: absolute;
  bottom: 0.6em;
  left: 0.6em;
  z-index:10;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #0081DB;
  background: #E6F5FF;
  border-radius: 16px;
  padding: 2px 8px 2px 6px;
  display: inline-flex;
  justify-content:center;

  span {
    display: inline-block;
  }
`;

const CardContent = styled.div`
  width: 50%;
  min-height: calc(176px * 0.8);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  padding: 0 1em;
  cursor: pointer;

  @media only screen and (max-width: 992px) { 
    width: 80%;
    justify-content:center;
    align-items:flex-start;
  }

  @media only screen and (max-width: 510px) { 
    width: 100%;
  }

  .organizer {
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    font-family: 'Inter';
  }

  .date > span {
    font-family: 'Inter';
    font-size: 16px;
    line-height: 19px;
  }
`;

export const Address = styled.span`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #0081DB;
    text-transform: capitalize;
`;

export default compose(
  withLocalize,
  connect(({ user }) => ({ user }),
    { push })
)(FeaturedTile);



// WEBPACK FOOTER //
// ./src/components/events/components/tile/featuredTile.js